module.exports = __webpack_public_path__ + "5b655b42df50bd5a7e41ea0f4950e8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/raise_message.png
// module id = 52
// module chunks = 0 1 2 3 4